import { type CSSProperties } from 'react';

const paddingValueRegex = /(\d*\.?\d+)(px|%)?/i;
export const convertPercentInPixels = (
  bodyWidth: number,
  containerPadding: CSSProperties['padding'],
) => {
  const paddings =
    typeof containerPadding === 'string' && containerPadding?.split(' ');

  if (!paddings) {
    return containerPadding;
  }

  const newPaddings = paddings.map((padding) => {
    const match = padding.match(paddingValueRegex);

    const [valueWithUnit, digit, unit] = match || [];

    if (!unit || !digit || !valueWithUnit) {
      return '';
    }

    if (unit === '%') {
      return +digit || +digit === 0 ? `${(bodyWidth * +digit) / 100}px` : '';
    }

    return valueWithUnit;
  });

  return newPaddings.join(' ');
};
